import React, { useEffect } from "react";
import "./SocialFeedback.css";
import TopicButton from "../../components/TopicButton/TopicButton";

function SocialFeedback() {
  const socialData = [
    {
      id: "a1",
      title: "中華民國退役將官社會服務總會",
      text: "總會長楊學仁中將頒贈榮譽狀-顧問團副團長",
      image1: "",
      image: "https://i.imgur.com/FIpiw6N.jpg",
      time: "2021年4月28日",
    },
    {
      id: "a2",
      title: "南投縣埔里鎮史港國民小學捐款",
      text: "宋文華董事長協助募款，捐助史港國小舞蹈才藝經費",
      image1: "",
      image: "https://i.imgur.com/A0gpiQV.jpg",
      time: "2022年10月5日",
    },
    {
      id: "a3",
      title: "財團法人臺中市私立向日葵社會福利慈善事業基金會",
      text: "宋文華董事長在向日葵基金會擔任董事，長期關注社會需求，積極參加公益活動",
      image1: "",
      image: "https://i.imgur.com/Pb0TAXu.jpg",
      time: "2023年2月1日",
    },
    {
      id: "a4",
      title: "財團法人榮民榮眷基金會",
      text: "祕書長李世國將軍，頒贈感謝狀",
    //   image1: "https://i.imgur.com/1TajVhB.jpg",
      image: "https://i.imgur.com/YcuRgmX.jpg",
      time: "2023年8月31日",
    },
    {
      id: "a5",
      title: "臺中市後備指揮部",
      text: "後備指揮官李育霖上校，頒贈感謝狀",
      text1: "協助本部推動各項全民國防工作，支持國防事務",
    //   image1: "https://i.imgur.com/rGiR8CI.jpg",
      image: "https://i.imgur.com/aPAVjuf.jpg",
      time: "2024年1月30日",
    },
    {
      id: "a6",
      title: "臺中市榮民服務處",
      text: "陳宗貴處長，頒贈感謝狀",
      text1: "慷慨捐助認養榮民遺孤，贊助之情",
    //   image1: "https://i.imgur.com/R1tt6Lf.jpg",
      image: "https://i.imgur.com/N4DneXd.jpg",
      time: "2024年3月7日",
    },
    {
      id: "a7",
      title: "花蓮縣震災捐款",
      text: "花蓮縣政府頒贈感謝狀",
      text1:
        "將各位捐贈者的愛心善款共募得150萬帶到花蓮，受款單位花蓮縣政府社會局弱勢兒童專戶50萬，花蓮縣家扶中心兒童救助50萬，花蓮縣畢士大教養院孤兒救助50萬，徐蓁蔚縣長親自接待",
    //   image1: "https://i.imgur.com/0mZGih3.png",
      image:
        "https://ws.hl.gov.tw/001/Upload/399/relpic/25832/157278/c0af3962-58eb-4146-97ed-7c1d8da3715a.jpg",
      time: "2024年5月7日",
    },
  ];

  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <TopicButton name="公益活動" />

      <div className="SocialFeedback-main">
        <section className="product">
          <div className="container">
            <ul className="productList">
              {socialData.map((item, index) => (
                <li
                  key={item.id}
                  id={item.id}
                  className={`productItem reveal ${
                    index % 2 !== 0 ? "reverse" : ""
                  }`}
                >
                  <div className="textBlock reveal">
                    <div className="textCard">
                      <h3 className="subTitle">{item.title}</h3>
                      <p>{item.text}</p>
                      {item.text1 && <p>{item.text1}</p>}
                      <p className="time">{item.time}</p>
                    </div>
                  </div>

                  <div className="mediaBlock reveal">
                    <img src={item.image} alt={item.title} className="mainImg" />

                    {item.image1 && (
                      <img
                        src={item.image1}
                        alt={`${item.title}附圖`}
                        className="subImg"
                      />
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </div>
    </>
  );
}

export default SocialFeedback;